import {
  GET_COMPLAIN,
  GET_COMPLAINS,
  GET_COMPLAINS_ERROR,
  GET_COMPLAINS_SUCCESS,
  GET_COMPLAIN_ERROR,
  GET_COMPLAIN_SUCCESS,
  SEND_COMPLAIN_REPLY,
  SEND_COMPLAIN_REPLY_ERROR,
  SEND_COMPLAIN_REPLY_SUCCESS,
  TOGGLE_NOTIFICATION_REPLY_MODAL,
} from "./actionTypes";

const initialState = {
  // complains
  loadingComplains: false,
  loadingComplainsSuccess: false,
  loadingComplainsError: null,
  complains: {},
  // add complain
  complain: {},
  // get complain
  getComplainLoading: false,
  getComplainError: null,
  getComplainSuccess: null,
  // send reply
  reply: {},
  sendReplyToComplainLoading: false,
  sendReplyToComplainError: null,
  sendReplyToComplainSuccess: false,
};

const complains = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPLAINS:
      state = {
        ...state,
        loadingComplains: true,
        loadingComplainsSuccess: false,
        loadingComplainsError: null,
        complains: [],
        complain: {},
        reply: {},
      };
      break;
    case GET_COMPLAINS_SUCCESS:
      state = {
        ...state,
        loadingComplains: false,
        loadingComplainsSuccess: true,
        loadingComplainsError: null,
        complains: action.payload,
      };
      break;
    case GET_COMPLAINS_ERROR:
      state = {
        ...state,
        loadingComplainsError: action.payload,
        loadingComplains: false,
        loadingComplainsSuccess: false,
        complains: [],
      };
      break;
    case GET_COMPLAIN:
      state = {
        ...state,
        complain: {},
        reply: {},
        getComplainLoading: true,
        getComplainSuccess: false,
        getComplainError: null,
      };
      break;
    case GET_COMPLAIN_SUCCESS:
      state = {
        ...state,
        getComplainError: null,
        getComplainSuccess: true,
        getComplainLoading: false,
        complain: action.payload,
      };
      break;
    case GET_COMPLAIN_ERROR:
      state = {
        ...state,
        getComplainError: action.payload,
        getComplainLoading: false,
        getComplainSuccess: false,
      };
      break;
    case SEND_COMPLAIN_REPLY:
      state = {
        ...state,
        sendReplyToComplainLoading: true,
        sendReplyToComplainSuccess: false,
        sendReplyToComplainError: null,
      };
      break;
    case SEND_COMPLAIN_REPLY_SUCCESS:
      state = {
        ...state,
        sendReplyToComplainLoading: false,
        sendReplyToComplainSuccess: true,
        sendReplyToComplainError: null,
        reply: {},
      };
      break;
    case SEND_COMPLAIN_REPLY_ERROR:
      state = {
        ...state,
        sendReplyToComplainLoading: false,
        sendReplyToComplainSuccess: false,
        sendReplyToComplainError: action.payload,
      };
      break;
    case TOGGLE_NOTIFICATION_REPLY_MODAL:
      state = {
        ...state,
        complain: {},
        reply: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default complains;
